@if (visible) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- backdrop dismiss already has a keyboard equivalent via the document-level Escape handler in dialog.component.ts -->
  <div class="cv-dialog-mask" (click)="onMaskClick()">
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -- stops backdrop click propagation, not an interactive control -->
    <div class="cv-dialog" [ngStyle]="getDialogStyles()" (click)="$event.stopPropagation()" *transloco="let translate">
      @if (header || headerTemplate) {
        <div class="cv-dialog-header">
          @if (headerTemplate) {
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
          } @else {
            <h2 class="cv-dialog-title">{{ header }}</h2>
          }
          <div class="cv-dialog-header-actions">
            <button class="cv-dialog-close" (click)="hideDialog()" type="button" [attr.aria-label]="translate('dialog.close')">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.707 7l3.647-3.646a.5.5 0 0 0-.708-.708L7 6.293 3.354 2.646a.5.5 0 0 0-.708.708L6.293 7l-3.647 3.646a.5.5 0 0 0 .708.708L7 7.707l3.646 3.647a.5.5 0 0 0 .708-.708L7.707 7Z"
                fill="currentColor"
              />
            </svg>
            </button>
          </div>
        </div>
      }
      <div class="cv-dialog-content">
        @if (contentTemplate) {
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        } @else {
          <ng-content class="gap-3"></ng-content>
        }
      </div>
    </div>
  </div>
}